import "./App.css";
import Main from "./Components/Main";
import Header from "./Components/Header";

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
